<template>
  <div>
    <div
      v-if="!entities || entities.length === 0"
      class="plus-minus-placeholder">
    </div>
    <template v-else-if="isActive">
      <img src="../../assets/minus.png" class="plus-minus" height="29" alt="entityName"/>
    </template>
    <template v-else>
      <img src="../../assets/Plus.svg" class="plus-minus" height="29" alt="entityName"/>
    </template>
  </div>
</template>
<script>

export default {
  name: 'PlusMinusControl',
  props: {
    entities: Array,
    entityName: String,
    isActive: Boolean,
  },
};
</script>
